import {Record, Map} from 'immutable';

import * as EmployeeActions from 'web-app/react/entities/employees/actions';
import {makeReducer, match} from 'web-app/util/redux';
import Employee, {type Employee as EmployeeModel} from 'web-app/react/entities/employees/model';

import * as Constants from './constants';
import * as Actions from './actions';

export class ManageEmployeeRightsState extends Record<{
    updating: boolean;
    employees: Map<string, EmployeeModel>;
    selectedRoleId: string;
    institutionId: string;
    addingEmployee: boolean;
}>({
    updating: true,
    employees: Map<string, EmployeeModel>(),
    selectedRoleId: Constants.filterAllEmployees,
    institutionId: '',
    addingEmployee: false,
}) {}

export default makeReducer<ManageEmployeeRightsState>(
    [
        match(EmployeeActions.fetchEmployeeSuccess, (state, {payload}) =>
            state.merge({
                employees: state.employees.set(payload.employee.employeeId, Employee.fromAPI(payload.employee)),
            }),
        ),

        match(EmployeeActions.updateGroup, (state, {payload}) =>
            state.merge({
                employees: state.employees.update(payload.employeeId, employee =>
                    employee.merge({
                        updating: true,
                        groupId: payload.groupId,
                    }),
                ),
            }),
        ),

        match(EmployeeActions.updateGroupSuccess, (state, {payload}) => {
            return state.merge({
                employees: state.employees.update(payload.employee.employeeId, employee =>
                    employee.merge({
                        updating: false,
                    }),
                ),
            });
        }),

        match(EmployeeActions.updateGroupFailed, (state, {payload}) =>
            state.merge({
                employees: state.employees.update(payload.employeeId, employee =>
                    employee.merge({
                        updating: false,
                    }),
                ),
            }),
        ),
        match(EmployeeActions.createEmployee, state =>
            state.merge({
                addingEmployee: true,
            }),
        ),
        match(EmployeeActions.createEmployeeSuccess, (state, {payload}) =>
            state.merge({
                selectedRoleId: Constants.filterAllEmployees,
                addingEmployee: false,
                employees: state.employees.set(payload.employee.employeeId, payload.employee),
            }),
        ),

        match(EmployeeActions.createEmployeeFailed, state =>
            state.merge({
                addingEmployee: false,
            }),
        ),

        match(Actions.fetchEmployees, state =>
            state.merge({
                updating: true,
            }),
        ),

        match(
            Actions.fetchEmployeesFailed,
            () =>
                new ManageEmployeeRightsState({
                    updating: false,
                }),
        ),
        match(Actions.fetchEmployeesSuccess, (state, {payload}) =>
            state.merge({
                updating: false,
                employees: Map(payload.employees.map(employee => [employee.employeeId, employee])),
                institutionId: payload.institutionId,
            }),
        ),

        match(Actions.filterByRole, (state, {payload}) =>
            state.merge({
                selectedRoleId: payload.roleId,
            }),
        ),
    ],
    new ManageEmployeeRightsState(),
);
